import { useEffect } from 'react'
import Helmet from 'react-helmet'
import { useTranslation } from 'react-i18next'

// local imports
import NotificationService from 'service/NotificationService'
import AuthUtil from 'utils/AuthUtil'
import Private from './Private'
import CampusServiceTracing from 'components/campus-service-tracing'

export default function CampusServiceTracingPage() {
  const { t } = useTranslation()

  const authorizationCheck = () => {
    let employee = AuthUtil.getEmployeeSummary()
    if (!AuthUtil.isSecurity(employee?.authList)) {
      NotificationService.showUnauthorizedRedirectionPopup(
        10000,
        'Yetkisiz Kullanıcı!',
        'Burayı görüntüleme yetkiniz yok!'
      ).then(() => {
        window.location.href = '/home'
      })
    }
  }

  useEffect(() => authorizationCheck(), [])

  return (
    <Private>
      <Helmet>
        <title>Koç Office Free - {t('nav-menu-items.campus-service-tracking')} </title>
        <meta
          name="description"
          content="Office Free ile ister şirketinden, ister Koç Topluluğu ortak ofislerinden çalışma planı gerçekleştirebilir, istersen de uzaktan çalışma bildirimi yapabilirsin."
        />
      </Helmet>

      <div className="container">
        <CampusServiceTracing />
      </div>
    </Private>
  )
}
